import { createFileRoute } from "@tanstack/react-router";
import WatIsTossen from "@/pages/WatIsTossen";

export const Route = createFileRoute("/wat-is-tossen")({
  head: () => ({
    meta: [
      { title: "Wat is tossen bij tennis? Betekenis, regels & tossavond | De Hussel App" },
      { name: "description", content: "Tossen bij tennis: wat betekent het, hoe werkt een tossavond op de club en hoe organiseer je het zonder gedoe? Complete uitleg met praktijkvoorbeelden." },
      { property: "og:title", content: "Wat is tossen bij tennis? Betekenis, regels & tossavond | De Hussel App" },
      { property: "og:description", content: "Tossen bij tennis: wat betekent het, hoe werkt een tossavond op de club en hoe organiseer je het zonder gedoe? Complete uitleg met praktijkvoorbeelden." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/wat-is-tossen" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/wat-is-tossen" }],
  }),
  component: WatIsTossen,
});
